// extracted by mini-css-extract-plugin
module.exports = {"downloadAlertMessage":"DownloadAlert_downloadAlertMessage__I7_fX"};